import Sidebar from "@/components/Sidebar";
import HelpButton from "@/components/HelpButton";
import OfflineIndicator from "@/components/OfflineIndicator";
import { Outlet } from "react-router-dom";

export default function Layout() {
  return (
    <div className="flex bg-slate-50 min-h-screen" data-testid="app-layout">
      <Sidebar />
      <main className="flex-1 min-w-0 flex flex-col">
        <div className="flex-1">
          <Outlet />
        </div>
        <footer
          data-testid="app-footer"
          className="border-t border-slate-200 bg-white px-6 py-3 text-center text-[11px] text-slate-500 tracking-wide"
        >
          © {new Date().getFullYear()} AMAL VBC — Plateforme développée par{" "}
          <span className="font-bold text-emerald-700">WSDK CONNECT</span>
        </footer>
      </main>
      <HelpButton />
      <OfflineIndicator />
    </div>
  );
}
